import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const initialState = {
  data: {},
};
export const slice = createSlice({
  name: "lastedForceSync",
  initialState: _.cloneDeep(initialState),
  reducers: {
    setLastedForceSync: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setLastedForceSync } = slice.actions;

export default slice.reducer;
